import { render, staticRenderFns } from "./BookingInvoice.vue?vue&type=template&id=55e4418e&"
import script from "./BookingInvoice.vue?vue&type=script&lang=ts&"
export * from "./BookingInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./BookingInvoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports